getSessionVariableKey = (placeId) ->
  return "mpp-recommendation-#{placeId}"

removeFromStorage = (placeId) ->
  sessionStorage?.removeItem getSessionVariableKey(placeId)

getFromStorage = (placeId) ->
  sessionStorage?.getItem getSessionVariableKey(placeId)

setToStorage = (placeId, value) ->
  if sessionStorage?
    sessionStorage.setItem getSessionVariableKey(placeId), value

class Recommendations

  constructor: ({ @el, @csrf, @placeId }) ->
    @$el = $ @el
    @rootUrl = '/merchant-page'
    @$thumbsUp = @$el.find '.recommendations-thumbs-up'
    @$thumbsDown = @$el.find '.recommendations-thumbs-down'

    @bindEventHandlers()

    # automatically recommend this merchant if the user previously intended to do so and then went through the login flow
    recommendation = getFromStorage @placeId
    removeFromStorage @placeId
    @recommend(recommendation, true) if recommendation in ['yes', 'no']

  bindEventHandlers: ->
    @$thumbsUp.click (evt) =>
      return unless @shouldAllowClick evt.currentTarget
      @recommend 'yes'

    @$thumbsDown.click (evt) =>
      return unless @shouldAllowClick evt.currentTarget
      @recommend 'no'

  shouldAllowClick: (el) ->
    # don't allow to click the thumbs up/down if the user has already clicked it
    $el = $ el
    not $el.hasClass('loading') and not $el.hasClass('highlighted') and not $('.mpp-container').hasClass('closed-merchant')

  showLoading: (recommend) ->
    if recommend is 'yes'
      @$thumbsUp.addClass 'loading'
    else
      @$thumbsDown.addClass 'loading'

  removeLoading: ->
    @$thumbsUp.removeClass 'loading'
    @$thumbsDown.removeClass 'loading'

  recommend: (recommend, triggeredOnPageLoad) ->
    obj =
      recommend: recommend
      placeId: @placeId
      triggeredOnPageLoad: triggeredOnPageLoad is true # force boolean value
      _csrf: @csrf

    @showLoading recommend

    $.ajax
      url: "#{@rootUrl}/recommendations"
      method: 'POST'
      data: JSON.stringify obj
      contentType: 'application/json'
      success: (res) =>
        @removeLoading()

        return setToStorage(@placeId, recommend) if MPP.JsonResponseHandler.loginRequired res

        # TODO handle other errors
        return unless res.result is 'ok'

        if recommend is 'yes'
          @$thumbsDown.removeClass 'highlighted'
          @$thumbsUp.addClass 'highlighted'
        else
          @$thumbsUp.removeClass 'highlighted'
          @$thumbsDown.addClass 'highlighted'


        if @$el.find('.recommendations-text').hasClass 'no-recommendations'
          @$el.find('.recommendations-placeholder').text I18n.t('js.modules.recommendations.thank_you')
        else

          total = res.data.recommendations.recommendation?.positive + res.data.recommendations.recommendation?.negative
          percent = res.data.recommendations.recommendation?.percentage

          @$el.find('.recommendations-total').text total
          @$el.find('.recommendations-percent').text "#{percent}%"

$ ->
  el = '#merchant-recommendations'
  return unless $(el).length > 0

  place = $('.mpp-container').data()
  csrfToken = $('meta[name=csrf-token]').attr('content')

  new Groupon.Recommendations {
    el: el
    csrf: csrfToken
    placeId: place.placeId
  }

Groupon.Recommendations = Recommendations
